import styled from "styled-components";
import { Input } from "antd";
import { theme } from "../../styles/theme";

export const CustomInputPassword = styled(Input.Password)`
  width: ${({ width }) => width || null};
  height: 50px;
  border: 1px solid ${theme.colors.light4};
  border-radius: 12px;
  opacity: 1;

  && {
    &.ant-input-affix-wrapper {
      .ant-input {
        color: ${theme.colors.grey};
        size: 16px;

        &::placeholder {
          color: ${theme.colors.grey1};
        }
      }

      &-focused {
        border: 1px solid ${theme.colors.light4};
        box-shadow: initial;
      }

      &:hover {
        border: 1px solid ${theme.colors.light4};
      }

      .anticon.ant-input-password-icon {
        color: ${theme.colors.light4};

        svg {
          width: 22px;
          height: 18px;
        }
      }

      .anticon.ant-input-password-icon {
        &:hover {
          color: ${theme.colors.light4};
        }
      }
    }
  }
`;
